export default __webpack_public_path__ + "static/media/745.eafc7c72.png";